import React from "react";

const SubmitButton = () => {
  return (
    <div className="row">
      <div className="col-md-12 text-center">
        <button type="submit" className="big_red">
          Dalej
        </button>
      </div>
    </div>
  );
};

export default SubmitButton;
